import { Component, EventEmitter, inject, Input, OnChanges, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FoundItem } from '../search.types';
import { stopPropagation } from 'ol/events/Event';
import { Inplace } from '@openng/optimus-ui/inplace';
import { folderUri } from '../../../../../utils/router.utils';
import { OrganizationGlobalStore } from '../../../../../store/organization.global-store';
import { ServiceGridItemObject } from '@it2go/types';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { Card } from '@openng/optimus-ui/card';
import { CheckOrCrossComponent } from '../../../../../components/kit/check-or-cross/check-or-cross.component';
import {
    ServiceColoredTagComponent,
} from '../../../../../components/medical-service/service-colored-tag/service-colored-tag.component';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';
import { ShortDatePipe } from '../../../../shared/pipes/short-date.pipe';
import { FormatAddressPipe } from '../../../../shared/pipes/format-address.pipe';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { LinkButtonComponent } from '../../../../../components/kit/button/link-button.component';
import { Tag } from '@openng/optimus-ui/tag';
import { LocalDatePipe } from '@libs/shared/pipes/local-date.pipe';
import { AuditLogTreeComponent } from '../../../../shared/components/audit-log-tree/audit-log-tree.component';

@Component({
    selector: 'app-search-result',
    templateUrl: 'search-result.component.html',
    styleUrl: 'search-result.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        Tooltip,
        TranslatePipe,
        Card,
        NgTemplateOutlet,
        CheckOrCrossComponent,
        ServiceColoredTagComponent,
        FormatPersonPipe,
        ShortDatePipe,
        FormatAddressPipe,
        Inplace,
        PrimeTemplate,
        LinkButtonComponent,
        Tag,
        LocalDatePipe,
        AuditLogTreeComponent,
    ],
})
export class SearchResultComponent implements OnChanges {
    private readonly router = inject(Router);


    public readonly organizationGlobalStore = inject(OrganizationGlobalStore);

    @Input() item!: FoundItem;
    @Input() withTag: boolean = false;
    @Output() clickChange = new EventEmitter();
    @ViewChild('historyTree') historyTree!: Inplace;

    protected severity = '';
    protected entityId = '';
    protected tagLabel = '';
    protected dateLabel = '';
    protected service: ServiceGridItemObject | null = null;
    protected link: string | null = null;
    protected copied = false;

    public ngOnChanges(): void {
        this.tagLabel = this.item.entity;
        this.entityId = this.item.data.id;
        if (this.item.entity === 'history') {
            this.tagLabel = this.item.data.entityName;
            this.entityId = this.item.data.entityId;
            const entityData = JSON.parse(this.item.data.data || '{}');
            if (entityData?.serviceId) {
                this.service = this.organizationGlobalStore.getServiceById(entityData!.serviceId)();
            }
        }

        switch (this.tagLabel) {
            case 'donor':
                this.severity = 'primary';
                this.dateLabel = 'donor.fields.createdAt';
                this.link = `/crm/donors/${this.entityId}`;
                break;
            case 'donation':
                this.severity = 'danger';
                this.dateLabel = 'donation.fields.receivedAt';
                this.link = `/crm/donations/${this.entityId}`;
                break;
            case 'collection':
                this.severity = 'success';
                this.dateLabel = 'donation.fields.createdAt';
                this.link = `/crm/collections/${this.entityId}`;
                break;
            case 'FolderModel':
            case 'folder': // TODO Tohle jsou deprecated klíče, nejprve potřeba sjednotit se CRM
                this.severity = 'primary';
                this.tagLabel = 'FolderModel';
                this.dateLabel = 'folder.fields.createdAt';
                this.link = folderUri(this.entityId, this.item.data.serviceInfo?.id);
                break;
            case 'PerformedProcedureModel':
            case 'performedProcedure':
                this.severity = 'danger';
                this.tagLabel = 'PerformedProcedureModel';
                this.dateLabel = 'procedures.performed.fields.dateFrom';
                this.link = null;
                break;
            default:
        }
        if (this.item.entity === 'history') {
            this.dateLabel = '';
        }
    }

    protected copyId(event: any): void {
        this.copied = true;
        setTimeout(() => {
            this.copied = false;
        }, 10);
        event.stopPropagation();
        navigator.clipboard?.writeText(this.entityId);
    }

    protected goto() {
        if (!this.link) return;
        this.router.navigate([this.link]);
        this.clickChange.emit();
    }

    protected hideHistoryTree(event: any): void {
        this.historyTree?.deactivate(event);
    }

    protected readonly stopPropagation = stopPropagation;
}
